import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import moment from 'moment';
import _ from 'lodash';
import 'c3/c3.css';

import { fetchJob } from '../../../actions/jobs';
import Dashboard from '../../Dashboard';
import { sortDates, sortStrings, toArray } from '../../../utils/helper';
import {
  extractAcknowledgements,
  groupAcknowledgementsByTypeDateStage,
  groupAcknowledgementsByTypeDateEmployee
} from '../../../utils/tasks';
import { fetchTasksRoutine } from '../../../routines';

import styles from './styles';
import EmployeeName from '../../Common/Lookup/EmployeeName';

// TODO move logic to api
const generate = (job = {}, tasks, subGroupName) => {
  console.log('job.profile', job);
  const stages = job.profile && job.profile.stages ? job.profile.stages : [];

  const items = _.flatten(toArray(tasks).filter((task) => task.items).map((task) => toArray(task.items).filter(item => !item.deleted)));
  const acknowledgements = _.flatten(items.map((item) => extractAcknowledgements(item, stages)));
  const itemsByType = _.groupBy(items, (item) => item.type ? item.type.id : 0);

  let subGroups;
  let groupedAcknowledgements;
  let subGroupHeader;

  switch (subGroupName) {
    case 'resources':
      subGroups = job && job.resources ? _.values(job.resources)
        .filter((resource) => resource.employee)
        .map((resource) => { return { id: resource.employee.id, name: resource.employee.id };}) : [];
      groupedAcknowledgements = groupAcknowledgementsByTypeDateEmployee(acknowledgements);
      subGroupHeader = (subGroup) => <EmployeeName id={subGroup.id}/>;
      break;
    default:
      subGroups = stages;
      groupedAcknowledgements = groupAcknowledgementsByTypeDateStage(acknowledgements);
      subGroupHeader = (subGroup) => subGroup.name;
      break;
  }

  console.log(subGroupName, 'subGroups', subGroups);
  console.log(subGroupName, 'acknowledgements', acknowledgements);
  const dates = _.uniq(acknowledgements.filter((ack) => ack.ack.acknowledged).map((ack) => moment(ack.ack.at).startOf('d').toISOString())).sort(sortDates);
  console.log(subGroupName, 'dates', dates);

  return {
    dates,
    itemsByType,
    groupedAcknowledgements,
    subGroups,
    items,
    subGroupHeader,
  };
};

const sortTypes = (a, b) => {
  const type1 = a[0].type || { id: 0, name: 'Unknown' };
  const type2 = b[0].type || { id: 0, name: 'Unknown' };

  return sortStrings(type1.name, type2.name);
};

class DetailedItemBreakdownReport extends Component {
  static propTypes = {
    fetchJob: PropTypes.func.isRequired,
    job: PropTypes.object.isRequired,
    fetchTasks: PropTypes.func.isRequired,
    tasks: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    dialogs: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
  };

  state = {
    subGroupName: 'stages',
    data: {
      resources: {
        itemsByType: {},
        dates: [],
        acknowledgedByTypeDate: {},
        subGroups: [],
        items: [],
      },
      stages: {
        itemsByType: {},
        dates: [],
        acknowledgedByTypeDate: {},
        subGroups: [],
        items: [],
      },
    },
  };

  componentWillMount() {
    const jobId = this.props.match.params.jobId;
    this.loadData(jobId);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.jobId !== nextProps.match.params.jobId) {
      this.loadData(nextProps.match.params.jobId);
      return;
    }

    if (!nextProps.job || !nextProps.tasks) {
      return;
    }

    console.log('nextProps.job', nextProps.job);

    this.setState({
      data: {
        resources: generate(nextProps.job, nextProps.tasks, 'resources'),
        stages: generate(nextProps.job, nextProps.tasks, 'stages'),
      },
    });
  }

  loadData(jobId) {
    this.props.fetchJob(jobId);
    this.props.fetchTasks(jobId);
  }

  renderNoData() {
    return (<div style={styles.noDataRow}>
      <FontIcon className="material-icons" style={styles.noData}>transform</FontIcon>
      <div>No tasks are available</div>
    </div>);
  }

  renderBreakdown = () => {
    const { items, itemsByType, dates, groupedAcknowledgements, subGroups, subGroupHeader } = this.state.data[this.state.subGroupName];

    console.log('dates', dates);
    console.log('subGroups', subGroups);
    console.log('itemsByType', itemsByType);
    return (<Table multiSelectable={false} selectable={false}>
      <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn></TableHeaderColumn>
          <TableHeaderColumn></TableHeaderColumn>
          { dates.map((date) => <TableHeaderColumn
            style={styles.dateColHeader}
            colSpan={subGroups.length}
            key={date}>{moment(date).format('ll')}</TableHeaderColumn>)}
        </TableRow>
        <TableRow>
          <TableHeaderColumn>Item Type</TableHeaderColumn>
          <TableHeaderColumn style={styles.totalCol}>Total</TableHeaderColumn>
          {_.flatten(dates.map(() => {
            return subGroups.map((subGroup) => <TableHeaderColumn
              style={styles.dateColHeader}
              key={subGroup.id}>{subGroupHeader(subGroup)}</TableHeaderColumn>);
          }))}
        </TableRow>
      </TableHeader>
      <TableBody displayRowCheckbox={false}>
        { _.values(itemsByType).sort(sortTypes).map((items) => {
          const type = items[0].type || { id: 0, name: 'Unknown' };
          return <TableRow key={type.id}>
            <TableRowColumn>{type.name}(s)</TableRowColumn>
            <TableRowColumn style={styles.totalCol} key="total">{items.length}</TableRowColumn>
            { dates.map((date) => {
              return _.flatten(subGroups.map((subGroup) => {
                const lookup = _.get(groupedAcknowledgements, [type.id, date, subGroup.id]);
                return (
                  <TableRowColumn style={styles.dateCol} key={date}>{lookup ? lookup.length : 0}</TableRowColumn>);
              }));
            })}
          </TableRow>;
        }) }

        <TableRow style={styles.totalRow}>
          <TableRowColumn>
            <div style={styles.total}>Total</div>
          </TableRowColumn>
          <TableRowColumn style={styles.totalCol}>
            <div style={styles.total}>{items.length}</div>
          </TableRowColumn>
          { dates.map((date) => {
            return _.flatten(subGroups.map((subGroup) => {
              const count = _.values(groupedAcknowledgements).reduce((res, type) => {
                return res + (_.get(type, [date, subGroup.id]) || []).length;
              }, 0);
              return (
                <TableRowColumn style={styles.dateCol} key={date}>
                  <div style={styles.total}>{count}</div>
                </TableRowColumn>);
            }));
          })}
        </TableRow>
      </TableBody>
    </Table>);
  };

  renderReport() {
    return (<div>
      <div style={styles.subGroups}>
        <RaisedButton
          primary={this.state.subGroupName === 'stages'}
          style={styles.subGroupNameButton}
          label="Group by Stage"
          onClick={() => this.setState({ subGroupName: 'stages' })}/>
        <RaisedButton
          primary={this.state.subGroupName === 'resources'}
          style={styles.subGroupNameButton}
          label="Group by Resource"
          onClick={() => this.setState({ subGroupName: 'resources' })}/>
      </div>
      { this.renderBreakdown() }
    </div>);
  }

  render() {
    const { job } = this.props;
    const customer = job && job.customer ? job.customer.name : 'Unknown';
    const description = job.description;
    // TODO split title onto two lines
    return (
      <Dashboard title={`Detailed Item Breakdown - ${customer} - ${description}`} subtitle="">
        { job.tasks && job.tasks.count ? this.renderReport() : this.renderNoData() }
      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchJob,
    fetchTasks: (jobId) => fetchTasksRoutine.trigger({ jobId }),
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    job: state.get('jobs').get('job').toJS(),
    tasks: state.get('tasks').get('tasks').toJS(),
    loading: state.get('jobs').get('loading'),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailedItemBreakdownReport);



// WEBPACK FOOTER //
// ./src/components/Reports/DetailedItemBreakdownReport/index.js